import * as React from "react";
import i18next from "i18next";
import Button from "@material-ui/core/Button";

export default function RefillBalance(props) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, fontSize: 18 }}>
      <div style={{ marginRight: 8 }}>
        {i18next.t("balance")}: {props.balance}
      </div>
      <Button variant="contained" onClick={props.moneyAdder}>
        {i18next.t("refill")}
      </Button>
      <input
        type="number"
        title={i18next.t("enter_value")}
        style={{ width: 150, maxWidth: "100%" }}
        value={props.moneyToAdd}
        onChange={(e) => props.stateSetter("add_money", e.target.value)}
      />
    </div>
  );
}
